import React from "react";

import { Layout, Flex } from "../../../../components/Layout";
import useWIndowResize from "../../../../hooks/useWIndowResize";
import SpacingBox from "../../../../components/SpacingBox";
import "./styles.css";
import brandsCard from '../../../../assets/images/footer/brand-cards.png'

const Footer = () => {
    const { isMobile } = useWIndowResize();
    return (
        <footer data-testid="footer" className="footer">
            <Layout
                id="footer"
                justify="center"
                direction={isMobile ? "column" : "row"}
                className="border-box"
            >
                <Flex order={isMobile ? 2 : 1} className="auto-height">
                    <Layout
                        id="infContacto"
                        className={isMobile ? "border-box-top" : "float-right"}
                        justify="center"
                    >
                        <SpacingBox pr={isMobile ? "" : "15"} py={isMobile ? "10" : "17"}>
                            <Layout
                                direction="column"
                                className="contact text-bold text-center"
                            >
                                <div>Te ayudamos con tu compra: (01) 513 -5025</div>
                                <div className="footer__address">
                                    Av. Juan de Arona 830, San Isidro - Lima 27
                                </div>
                            </Layout>
                        </SpacingBox>
                    </Layout>
                </Flex>
                <Flex order={isMobile ? 1 : 2} className="align-self-center">
                    <Layout
                        pl={isMobile ? "" : "10"}
                        id="cards"
                        className={isMobile ? " " : "float-left"}
                        justify="center"
                    >
                        <Layout>
                            <SpacingBox p={isMobile ? "10" : "15"}>
                                <img
                                    title="marcas tarjetas"
                                    src={brandsCard}
                                    alt="footer cards"
                                    className="footer__cards"
                                />
                            </SpacingBox>
                        </Layout>
                    </Layout>
                </Flex>
            </Layout>

            <Layout justify="center">
                <Layout className="text-center fw-bold" p={isMobile ? "5" : "10"}>
                    <b>
                        Pacífico Compañía de Seguros y Reaseguros / RUC: 20332970411 -
                        Pacífico S.A. Entidad Prestadora de Salud / RUC: 20431115825
                    </b>
                </Layout>
            </Layout>

            <Layout id="recaptcha" className="footer__captcha" justify="center">
                <Layout className="text-center" pb={isMobile ? "10" : "15"}>
                    <p>
                        Esta página web está protegida por reCAPTCHA y se aplican las{" "}
                        <a
                            data-testid="footerPoliticasLink"
                            className="text-secondary"
                            href="https://policies.google.com/privacy"
                            rel="noopener noreferrer"
                            target="_blank"
                        >
                            Políticas de privacidad
                        </a>{" "}
                        y los{" "}
                        <a
                            data-testid="footerTerminosLink"
                            className="text-secondary"
                            href="https://policies.google.com/terms"
                            rel="noopener noreferrer"
                            target="_blank"
                        >
                            Términos de servicio
                        </a>{" "}
                        de Google.
                    </p>
                </Layout>
            </Layout>
        </footer>
    );
};

export default Footer;
